export default __webpack_public_path__ + "static/caption-02-jp-7b721cdacae39d0c48bc51de572d1abd.png";